// Centralized API base — never hardcode the domain.
// - Local dev (localhost): use REACT_APP_BACKEND_URL so the dev server can reach
//   the backend.
// - Any real domain (preview or production, e.g. registrasi-magang.indilabs.co.id):
//   call the SAME origin, where the ingress routes "/api" to the backend. This way
//   the deployed app automatically uses its own domain with zero code changes.
const envUrl = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');

function resolveBase() {
  if (typeof window === 'undefined') return envUrl;
  const host = window.location.hostname;
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  if (isLocal && envUrl) return envUrl;
  return window.location.origin.replace(/\/$/, '');
}

export const API_BASE = resolveBase();
export const API = `${API_BASE}/api`;
